<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <router-link class="btn btn-primary" :to="{ name: 'teams-new.create' }"><i class="fa fa-plus"></i>
          Criar</router-link>
        <exporter grid-ref="teamGrid" :url="url + '/exportnew'"></exporter>
      </div>
      <grid-filters grid-data="teamGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="teamGrid" name="teamGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable="true" :filterable="true" :sortable="true" v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
    <b-modal no-enforce-focus @shown="showModal = true" @hidden="showModal = false" ref="teamsModalDelete"
      id="teamsModalDelete">
      <p>Apagar a relação?</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" variant="secondary" @click="hideModal">
          Cancelar
        </b-btn>
        <b-btn size="sm" class="float-right" variant="danger" @click="doDelete">
          Apagar
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import lists from "@/components/States.js";

export default {
  name: "teamGrid",
  components: {
    Grid,
  },
  data() {
    return {
      itemToDelete: null,
      filters: {
        dsr: null,
        dsr_id: null,
      },
      gridFilters: [
        {
          field: "dsr_id",
          modal: "dsr-new-modal",
          foreign: "id",
          placeholder: "DSR",
        },
        {
          field: "leader_id",
          modal: "dsr-new-modal",
          foreign: "id",
          placeholder: "Leader",
        },
      ],
      schemaModelFields: {
        created_at: {
          type: "date",
        },
        updated_at: {
          type: "date",
        },
        date_start: {
          type: "string",
        },
        date_end: {
          type: "string",
        },
        username:
        {
          type: "string",
        },
        leader_username:
        {
          type: "string",
        },
        dsr_name: {
          type: "string"
        },
        leader_name: {
          type: "string"
        }
      },
      preload: [
        {
          api: "dsrnew/lstnew/dsrnew",
          field: "dsr_id",
        },
        {
          api: "dsrnew/lstnew/leadersnew",
          field: "leader_id",
        },
        {
          api: "dealersnew/lstnew",
          field: "dealer_id",
        },
      ],
      url: "teamsnew",
      columns: [
        {
          template: this.getBtnTemplate,
          title: "",
          width: "120px",
        },
        {
          field: "username",
          title: "DSR - Username",
          width: "220px",
        },
        {
          field: "dsr_name",
          title: "DSR",
          width: "220px",
        },
        {
          field: "leader_username",
          title: "Líder - Username",
          width: "220px",
        },
        {
          field: "leader_name",
          title: "Líder",
          width: "220px",
        },
        {
          field: "state",
          title: "Estado",
          values: lists.dsrStates,
          width: "150px",
        },
        {
          field: "date_start",
          title: "Inicio",
          template: (dataItem) =>
            dataItem.date_start ? dataItem.date_start.split("T")[0] : "",
          width: "180px",
          filterable: {
            ui: function (element) {
              // element is a jQuery object (kendo passes it)
              var $input = element && element.jquery ? element : $(element);

              // keep original width
              $input.css("width", "100%");

              // add Kendo text styling + bootstrap form control so it looks like other inputs
              $input.addClass("k-textbox form-control");

              // optional placeholder
              $input.attr("placeholder", "YYYY-MM-DD");

              // attach auto-dash formatting
              $input
                .off("input.kendoAutoDash")
                .on("input.kendoAutoDash", function () {
                  var val = $input.val() || "";
                  var digits = val.replace(/\D/g, "").slice(0, 8);
                  var out = digits;
                  if (digits.length > 4)
                    out = digits.slice(0, 4) + "-" + digits.slice(4);
                  if (digits.length > 6)
                    out =
                      digits.slice(0, 4) +
                      "-" +
                      digits.slice(4, 6) +
                      "-" +
                      digits.slice(6);
                  $input.val(out);
                });
            },
          },
          // filterable: {
          //   // ui: "datetimepicker"
          //   ui: function (element) {
          //     element.kendoDateTimePicker({
          //       format: "dd/MM/yyyy",
          //     });
          //   },
          // },
        },
        {
          field: "date_end",
          title: "Fim",
          template: (dataItem) =>
            dataItem.date_end ? dataItem.date_end.split("T")[0] : "",
          width: "180px",
          filterable: {
            ui: function (element) {
              // element is a jQuery object (kendo passes it)
              var $input = element && element.jquery ? element : $(element);

              // keep original width
              $input.css("width", "100%");

              // add Kendo text styling + bootstrap form control so it looks like other inputs
              $input.addClass("k-textbox form-control");

              // optional placeholder
              $input.attr("placeholder", "YYYY-MM-DD");

              // attach auto-dash formatting
              $input
                .off("input.kendoAutoDash")
                .on("input.kendoAutoDash", function () {
                  var val = $input.val() || "";
                  var digits = val.replace(/\D/g, "").slice(0, 8);
                  var out = digits;
                  if (digits.length > 4)
                    out = digits.slice(0, 4) + "-" + digits.slice(4);
                  if (digits.length > 6)
                    out =
                      digits.slice(0, 4) +
                      "-" +
                      digits.slice(4, 6) +
                      "-" +
                      digits.slice(6);
                  $input.val(out);
                });
            },
          },
          // filterable: {
          //   // ui: "datetimepicker"
          //   ui: function (element) {
          //     element.kendoDateTimePicker({
          //       format: "dd/MM/yyyy",
          //     });
          //   },
          // },
        },
        {
          field: "created_at",
          title: "Criado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            // ui: "datetimepicker"
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
        {
          field: "updated_at",
          title: "Atualizado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            // ui: "datetimepicker"
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        }
      ],
    };
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "teams-new.edit",
        params: {
          id: item.id,
        },
      });
      if (this.$auth.check("teams-new.edit")) {
        return (
          '<a href="' +
          route.href +
          '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
        );
      }
      return "";
    },
    deleteItem(e) {
      e.preventDefault();
      var grid = this.$refs.teamGrid.getGridWidget();
      var dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
      this.itemToDelete = dataItem.id;
      this.$refs.teamsModalDelete.show();
    },
    doDelete(e) {
      this.axios.delete("teams/" + this.itemToDelete).then((response) => {
        this.$refs.teamsModalDelete.hide();
        this.$refs.teamGrid.reload();
        this.itemToDelete = null;
      });
    },
    hideModal: function () {
      this.$refs.Teams_ViewModalDelete.hide();
    },
  },
};
</script>
